/* ============================================================================
   Joe's Kitchen — Dark "Crave" Contact interactions
   - FAQ split: question index on the left swaps the answer pane on the right
   - Light client-side validation on the (real Shopify) contact form
   ============================================================================ */
(function () {
  /* ---------------------------------------------------- FAQ SPLIT ---------- */
  (function () {
    const nav = document.getElementById('jkFaqNav');
    const pane = document.getElementById('jkFaqPane');
    const data = document.getElementById('jkFaqData');
    if (!nav || !pane || !data) return;
    const items = Array.from(data.querySelectorAll('.faq-item'));
    const btns = Array.from(nav.querySelectorAll('button'));

    function select(i) {
      btns.forEach((b, j) => b.classList.toggle('active', j === i));
      const it = items[i];
      if (!it) return;
      pane.innerHTML =
        '<div class="fp-cat">' + (it.dataset.cat || '') + '</div>' +
        '<h3 class="fp-q">' + (it.dataset.q || '') + '</h3>' +
        '<div class="fp-a">' + it.innerHTML + '</div>';
      pane.classList.remove('swap'); void pane.offsetWidth; pane.classList.add('swap');
    }
    btns.forEach((b, i) => b.addEventListener('click', () => select(i)));
    if (btns.length) select(0);
  })();

  /* ------------------------------------------------- FORM VALIDATION ------- */
  (function () {
    const form = document.getElementById('jkContactForm');
    if (!form) return;
    const name = form.querySelector('[name="contact[name]"]');
    const email = form.querySelector('[name="contact[email]"]');
    const msg = form.querySelector('[name="contact[body]"]');
    const required = [name, email, msg].filter(Boolean);

    required.forEach((f) => f.addEventListener('input', () => f.classList.remove('invalid')));

    form.addEventListener('submit', (e) => {
      let ok = true;
      required.forEach((f) => {
        if (!f.value.trim()) { f.classList.add('invalid'); ok = false; }
        else f.classList.remove('invalid');
      });
      if (email && email.value && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) {
        email.classList.add('invalid'); ok = false;
      }
      if (!ok) { e.preventDefault(); } // otherwise let it post to Shopify for real
    });
  })();
})();
